import { render, staticRenderFns } from "./PleaseLoginButton.vue?vue&type=template&id=602e95d8&lang=pug"
import script from "./PleaseLoginButton.vue?vue&type=script&lang=js"
export * from "./PleaseLoginButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports